/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      // {
      //   Header: 'Production Schedule',
      //   accessor: 'production_schedule_name',
      // },
      // {
      //   Header: 'Product Name',
      //   accessor: 'product_name',
      // },
      {
        Header: 'tableCommon.batch_code',
        accessor: 'batch_code',
      },
      {
        Header: 'tableCommon.batchGRN',
        accessor: 'batch_grn',
      },
      {
        Header: 'tableCommon.manufacturingDate',
        accessor: 'manufacturing_date',
      },
      {
        Header: 'Batch Expiry Date',
        accessor: 'expiry_date',
      },
      {
        Header: 'tableCommon.lot_count',    
        accessor: 'lot_count',
      },
      {
        Header: 'tableCommon.plateType',    
        accessor: 'plateType',
      },
      {
        Header: 'tableCommon.plateCount',    
        accessor: 'quantity',
      },
      {
        Header: 'TCM Status',    
        accessor: 'tcm_status',
      },
      {
        Header: 'tableCommon.status',    
        accessor: 'status',
      },
]

export const Lotcolumns: TableColumn[] = [
  {
      Header: 'tableCommon.sl_no',
      accessor: 'slno',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    {
      Header: 'tableCommon.plate_count',    
      accessor: 'plate_count',
    },
    {
      Header: 'tableCommon.status',    
      accessor: 'inspection_status',
    },
]


export const Platecolumns: TableColumn[] = [
  {
      Header: 'tableCommon.sl_no',
      accessor: 'slno',
    },
    {
      Header: 'Production Schedule',
      accessor: 'production_schedule_name',
    },
    {
      Header: 'Product Name',
      accessor: 'product_name',
    },
    {
      Header: 'tableCommon.seriel_number',
      accessor: 'serial_number',
    },
    {
      Header: 'tableCommon.batch_code',
      accessor: 'batch_number',
    },
    {
      Header: 'tableCommon.activityType',
      accessor: 'master_activity_name',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    {
      Header: 'tableCommon.status',    
      accessor: 'plate_status',
    },
]

interface TableColumn {
    Header: string;
    accessor: string;
  }
